import type { Swiper as SwiperType } from "swiper";

/**
 * `updateOnWindowResize={false}` + `content-visibility: auto` birlikte bir tuzak
 * kuruyor:
 *
 *   • updateOnWindowResize=false iken Swiper, ResizeObserver'ın yaydığı `resize`
 *     olayına kendi `onResize` işleyicisini BAĞLAMIYOR (swiper-core: yalnızca
 *     `observerUpdate` dinleniyor).
 *   • content-visibility ile ertelenen bir section'da Swiper hidrasyon anında
 *     0 genişlikte init oluyor — atlanmış alt ağacın layout'u yok.
 *   • Bölüm ekrana girip gerçek genişliğe kavuştuğunda kimse ölçümü tazelemiyor;
 *     slide genişlikleri 0'da kalıyor ve carousel bozuk görünüyor.
 *
 * Bu işleyici yalnızca o boşluğu kapatır. ResizeObserver `resize`'ı zaten sadece
 * boyut GERÇEKTEN değiştiğinde yayınladığı için ekstra iş üretmez; pencere
 * yeniden boyutlandırma yolu kapalı kalmaya devam eder.
 */
export const reviveSwiperOnResize = (swiper: SwiperType) => {
  if (!swiper || swiper.destroyed) return;
  // Hâlâ atlanmış durumdaysa ölçüm anlamsız — bir sonraki resize'ı bekle.
  if (!swiper.el?.offsetWidth) return;
  swiper.update();
};
